export default __webpack_public_path__ + "static/media/water@2x.f770b9e6.png";